import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function FullscreenInfo({ message }) {
  const { t } = useTranslation();
  return (
    <div className="fullscreen-placeholder">
      <h1>{t(message)}</h1>
    </div>
  );
}

FullscreenInfo.propTypes = {
  message: PropTypes.string.isRequired
};

export default FullscreenInfo;
